import theme from 'theme'

const ITEM_HEIGHT = 32
const ITEM_PADDING_TOP = 8

export const formControlSx = {
  my: 1,
  width: 320,

  '.MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${theme.colors.rawSienneCore}`
  },

  '.MuiInputLabel-root': {
    color: theme.colors.white
  }
}

export const menuItemSx = {
  '.MuiList-root .MuiMenu-list': {
    paddingTop: '0 !important'
  },

  '.MuiTypography-root': {
    fontSize: theme.typography.fontSize.large,
    lineHeight: '18px',
    fontWeight: theme.typography.fontWeight.normal,
    color: 'rgba(20, 12, 64, 0.9)'
  },

  '&.Mui-selected': {
    background: 'transparent'
  }
}

export const MenuProps = {
  PaperProps: {
    sx: {
      transform: 'translateY(-15px) !important'
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 280,
      left: '200px !important'
    }
  }
}

export const selectSx = {
  color: '#000',
  fontSize: theme.typography.fontSize.xLarge,
  lineHeight: '24px',
  maxWidth: '300px',
  maxHeight: '32px',
  background: theme.colors.white
}

export const selectInputSx = {
  color: '#rgba(20, 12, 64, 0.5)',
  fontSize: theme.typography.fontSize.xLarge,
  lineHeight: '24px'
}
